import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, ElementRef, EventEmitter, OnInit, TemplateRef, ViewContainerRef, ViewRef } from '@angular/core';
import { BooleanConverter } from '../../../inputConverter';
import { BaseComponent } from '../../base.component';
var SelectComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SelectComponent, _super);
    function SelectComponent(_vcr, cdr) {
        var _this = _super.call(this, _vcr) || this;
        _this.cdr = cdr;
        _this._canAddCustom = false;
        _this._data = null;
        _this._hasVirtualScroll = false;
        _this._isClearable = true;
        _this._isDisabled = false;
        _this._isLoading = false;
        _this._isMultiSelect = false;
        _this._isSearchable = false;
        _this.loadedData = null;
        _this.numberOfItemsFromEndBeforeLoadMore = 5;
        _this.searchTerm = null;
        _this.optionTemplate = null;
        _this.controlLabel = 'Value';
        _this.label = '';
        _this.pageSize = 1000;
        _this.placeholderText = '';
        _this.value = '';
        _this.addEvent = new EventEmitter();
        _this.blurEvent = new EventEmitter();
        _this.clearEvent = new EventEmitter();
        _this.closeEvent = new EventEmitter();
        _this.focusEvent = new EventEmitter();
        _this.modelChange = new EventEmitter();
        _this.openEvent = new EventEmitter();
        _this.removeEvent = new EventEmitter();
        _this.searchEvent = new EventEmitter();
        _this.formatCustom = function (label) {
            if (_this.canAddCustom) {
                var customItem = {};
                customItem[_this.label] = label;
                customItem[_this.value] = label;
                return customItem;
            }
            else {
                return false;
            }
        };
        return _this;
    }
    Object.defineProperty(SelectComponent.prototype, "canAddCustom", {
        get: function () {
            return this._canAddCustom;
        },
        set: function (value) {
            this._canAddCustom = BooleanConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SelectComponent.prototype, "data", {
        get: function () {
            return this._data;
        },
        set: function (value) {
            this._data = typeof value === 'string' ? JSON.parse(value) : value;
            if (!this._data) {
                this.loadedData = null;
            }
            else if (this.hasVirtualScroll) {
                this.loadedData = [];
                this.loadMoreData();
            }
            else {
                this.loadedData = [].concat(this._data);
            }
            this.showSelectedValue(false);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SelectComponent.prototype, "hasVirtualScroll", {
        get: function () {
            return this._hasVirtualScroll;
        },
        set: function (value) {
            this._hasVirtualScroll = BooleanConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SelectComponent.prototype, "isClearable", {
        get: function () {
            return this._isClearable;
        },
        set: function (value) {
            this._isClearable = BooleanConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SelectComponent.prototype, "isDisabled", {
        get: function () {
            return this._isDisabled;
        },
        set: function (value) {
            this._isDisabled = BooleanConverter(value);
            this.toggleDisabled();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SelectComponent.prototype, "isLoading", {
        get: function () {
            return this._isLoading;
        },
        set: function (value) {
            this._isLoading = BooleanConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SelectComponent.prototype, "isMultiSelect", {
        get: function () {
            return this._isMultiSelect;
        },
        set: function (value) {
            this._isMultiSelect = BooleanConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SelectComponent.prototype, "isSearchable", {
        get: function () {
            return this._isSearchable;
        },
        set: function (value) {
            this._isSearchable = BooleanConverter(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SelectComponent.prototype, "model", {
        get: function () {
            return this._model;
        },
        set: function (value) {
            if (this._model !== value) {
                this._model = value;
                this.showSelectedValue(false);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SelectComponent.prototype, "searchBox", {
        get: function () {
            return this.selectRef.element.querySelector('input');
        },
        enumerable: true,
        configurable: true
    });
    SelectComponent.prototype.ngOnInit = function () {
        try {
            this.registerEvent('addEvent', this.addEvent);
            this.registerEvent('blurEvent', this.blurEvent);
            this.registerEvent('clearEvent', this.clearEvent);
            this.registerEvent('closeEvent', this.closeEvent);
            this.registerEvent('focusEvent', this.focusEvent);
            this.registerEvent('modelChange', this.modelChange);
            this.registerEvent('openEvent', this.openEvent);
            this.registerEvent('removeEvent', this.removeEvent);
            this.registerEvent('searchEvent', this.searchEvent);
        }
        catch (error) {
            this.readyProblem(error);
        }
        finally {
            this.isReady();
        }
    };
    SelectComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.toggleDisabled();
        // When items are added to the dropdown, the search box is cleared. Capture the search as the user types so it can be put back.
        this.selectRef.element.querySelector('input').addEventListener('input', function (e) {
            _this.searchTerm = e.target.value;
        });
    };
    SelectComponent.prototype.loadMoreData = function () {
        var _this = this;
        var additionalData = this._data.slice(this.loadedData.length, this.pageSize + Number(this.loadedData.length));
        this.toggleLoading(true);
        this.loadedData = this.loadedData.concat(additionalData);
        if (this.searchTerm) {
            this.searchBox.readOnly = true;
            setTimeout(function () {
                _this.searchBox.value = _this.searchTerm;
                _this.selectRef.filter(_this.searchTerm);
                _this.searchBox.readOnly = false;
            }, 0);
        }
        if (this.loadedData.length < this._data.length) {
            setTimeout(function () { return _this.loadMoreData(); }, 250);
        }
        else {
            this.toggleLoading(false);
        }
    };
    SelectComponent.prototype.onAdd = function (event) {
        this.addEvent.emit(event);
    };
    SelectComponent.prototype.onBlur = function (event) {
        this.blurEvent.emit(event);
    };
    SelectComponent.prototype.onChange = function (_event) {
        this.searchTerm = null;
        this.showSelectedValue(true);
    };
    SelectComponent.prototype.onClear = function () {
        this.setDropdownPanelStyle();
        this.clearEvent.emit();
    };
    SelectComponent.prototype.onClose = function () {
        if (this.searchTerm !== null && this._model !== this.searchTerm) {
            this.searchTerm = null;
            this.showSelectedValue(false);
        }
        var selectElement = this.selectRef.element;
        var dropdownPanel = selectElement.querySelectorAll('.ng-dropdown-panel')[0];
        dropdownPanel.style.opacity = '0';
        this.closeEvent.emit();
    };
    SelectComponent.prototype.onFocus = function (event) {
        this.focusEvent.emit(event);
    };
    SelectComponent.prototype.onOpen = function () {
        this.setDropdownPanelStyle();
        this.openEvent.emit();
    };
    SelectComponent.prototype.onRemove = function (event) {
        this.setDropdownPanelStyle();
        this.removeEvent.emit(event);
    };
    SelectComponent.prototype.onSearch = function (event) {
        this.searchTerm = event.term;
        this.searchEvent.emit(event);
    };
    SelectComponent.prototype.setDropdownPanelStyle = function () {
        var _this = this;
        // Dropdown with items needs fixed position and location set manually to ensure is not contained within popup and do not need to scroll popup to view items
        setTimeout(function () {
            var selectElement = _this.selectRef.element;
            var dropdownPanel = selectElement.querySelectorAll('.ng-dropdown-panel')[0];
            if (dropdownPanel) {
                var selectContainerBoundingBox = selectElement.querySelectorAll('.ng-select-container')[0].getBoundingClientRect();
                dropdownPanel.style.opacity = '1';
                dropdownPanel.style.left = selectContainerBoundingBox.left + "px";
                dropdownPanel.style.top = selectContainerBoundingBox.bottom + "px";
                dropdownPanel.style.width = selectContainerBoundingBox.width + "px";
            }
        }, 0);
    };
    SelectComponent.prototype.showSelectedValue = function (shouldTriggerEvent) {
        var _this = this;
        setTimeout(function () {
            var selectElement = _this.selectRef.element;
            if (_this.isMultiSelect && _this._model) {
                var valueLabels_1 = selectElement.querySelectorAll('.ng-value-label');
                if (valueLabels_1 && valueLabels_1.length > 0) {
                    _this._model.forEach(function (selectedItem, index) {
                        if (_this.loadedData && !_this.loadedData.find(function (data) { return data[_this.value] === selectedItem; })) {
                            var modelData = _this.data.find(function (data) { return data[_this.value] === selectedItem; });
                            if (modelData) {
                                valueLabels_1[index].innerText = modelData[_this.label];
                            }
                            else {
                                valueLabels_1[index].innerText = selectedItem;
                            }
                        }
                        else if (!_this.loadedData) {
                            valueLabels_1[index].innerText = selectedItem;
                        }
                    });
                }
            }
            else if (!_this.isMultiSelect) {
                var valueLabel = selectElement.querySelectorAll('.ng-value-label')[0];
                var input = selectElement.querySelectorAll('input')[0];
                if (_this.loadedData && _this._model && !_this.loadedData.find(function (data) { return data[_this.value] === _this._model; })) {
                    var modelData = _this.data.find(function (data) { return data[_this.value] === _this._model; });
                    if (modelData) {
                        valueLabel.innerText = modelData[_this.label];
                        input.value = modelData[_this.label];
                    }
                    else {
                        valueLabel.innerText = _this.model;
                        input.value = _this.model;
                    }
                }
                else {
                    input.value = valueLabel ? valueLabel.innerText : '';
                }
            }
            if (_this.cdr && !_this.cdr.destroyed) {
                _this.cdr.detectChanges();
            }
            if (shouldTriggerEvent) {
                _this.modelChange.emit(_this.model);
            }
        }, 1);
    };
    SelectComponent.prototype.toggleDisabled = function () {
        var selectElement = this.selectRef.element;
        var input = selectElement.querySelectorAll('input')[0];
        if (input) {
            if (this._isDisabled) {
                input.setAttribute('disabled', '');
            }
            else {
                input.removeAttribute('disabled');
            }
        }
    };
    SelectComponent.prototype.toggleLoading = function (isLoading) {
        this.isLoading = isLoading;
        this.cdr.detectChanges();
    };
    return SelectComponent;
}(BaseComponent));
export { SelectComponent };
